import {Injectable} from '@angular/core';
import {EventInfo} from "../common/classes";
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GlobalEventsService {
  private dataList: any = {};
  private dataSubject = new Subject<EventInfo>();
  private dataFlow = this.dataSubject.asObservable();
  private subscriptions: Map<string, { [id: string]: Function[] }> = new Map();

  constructor() {
    this.dataFlow.subscribe((data: EventInfo) => this._onEvent(data));
  }

  notifyDataChanged<T>(event: string, value: T): void {
    let current = this.dataList[event];
    if (current !== value) {
      this.dataList[event] = value;
      this.dataSubject.next({
        event: event,
        data: value
      });
    }
  }

  public subscribe(event: string, id: string = 'global', callback: Function): void {
    let subscriber = this.subscriptions.get(event) || Object.create(null);
    let cbs = subscriber[id] = subscriber[id] || [];
    cbs.push(callback);
    this.subscriptions.set(event, subscriber);
  }

  public unsubscribe(event: string, id: string = 'global'): void {
    let subscriber = this.subscriptions.get(event) || Object.create(null);
    delete subscriber[id]
  }

  private _onEvent(evenInfo: EventInfo): void {
    let subscriber = this.subscriptions.get(evenInfo.event) || Object.create(null);
    let data = evenInfo.data;
    for (const key in subscriber) {
      let cbs = subscriber[key] || [];
      cbs.forEach((cb: any) => {
        cb.call(null, data)
      })
    }
  }
}
